import { conditions } from "helpers";
import { ConditionName } from "interfaces";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { setActiveElements } from "redux-share/slices/controllerSlice";
import { setSettingPopover } from "redux-share/slices/popoversSlice";
import { setSelectedAudioId } from "redux-share/slices/videoDataSlice";
import ChevronRightIcon from "../../icon-components/chevronRight";
import { shallowEqual } from 'react-redux'

const MultiAudio = ({ setSection }: any) => {

    const dispatch = useAppDispatch();
    const { multiAudio, selectedAudioId } = useAppSelector(({ videoData: { multiAudio, selectedAudioId } }) => ({ multiAudio, selectedAudioId }), shallowEqual);

    return (
        <div id="multiAudio" className="animate__animated animate__fadeIn">
            <div className="pl-flex pl-items-center pl-cursor-pointer" onClick={() => setSection("main")}>
                <ChevronRightIcon className="pl-absolute !pl-right-[5px] pl-w-5 pl-h-5 pl-stroke-gray-800 dark:pl-stroke-dark-5" />
                <p className="pl-text-[15px] pl-font-medium pl-py-3 pl-pr-12">انتخاب زبان</p>
            </div>
            <ul className="pl-flex pl-flex-col pl-p-0 pl-m-0">
                {conditions(ConditionName.hasMultiAudio) && multiAudio.map((audio: any, index:number) => (
                    <li
                        key={audio.id}
                        className={`pl-flex pl-items-center pl-text-[14px] pl-pr-12 pl-relative pl-cursor-pointer pl-leading-6 hover:pl-bg-main/[0.1] hover:dark:pl-bg-white/[0.25] pl-p-1 ${selectedAudioId === index && "pl-tick-icon pl-bg-main-light hover:!pl-bg-main-light  pl-text-dark-5"}`}
                        onClick={() => {
                            dispatch(setSelectedAudioId(index));
                            setSection("main");
                            dispatch(setActiveElements(false));
                            dispatch(setSettingPopover(false));
                        }}
                    >
                        <span>{audio.name}</span>
                        {index === 0 && <span>(پیش فرض)</span>}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default MultiAudio;